import { Link } from "react-router-dom";
import { SiteFooter } from "@/components/SiteFooter";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you generate a jingle preview we collect your name, email address, and website URL. When you purchase, payment details are collected and processed directly by Stripe — we never see or store your full card number. We also store the takes generated for your website so you can return to them.",
  },
  {
    title: "How we use it",
    body: "Your email is used to deliver your jingle previews, receipts, download links, and follow-up messages about your session (for example, a reminder that your preview is ready). Your website URL is used solely to generate your jingle. We do not sell, rent, or share your personal information with third parties for their marketing.",
  },
  {
    title: "Third-party processors",
    body: "We use Stripe for payments and a transactional email provider for delivery. Each processes only the data needed to perform its function, under its own privacy policy.",
  },
  {
    title: "Your choices",
    body: "Reply to any email we send to opt out of follow-ups, request a copy of your data, or ask us to delete your session. You can also email jon@getlocalbusinessjingle.com for any privacy request.",
  },
  {
    title: "Data retention",
    body: "Preview sessions and generated takes are retained so you can return and purchase later. Contact us any time to have your session and personal data removed.",
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-obsidian text-white flex flex-col">
      <header className="mx-auto w-full max-w-4xl px-4 sm:px-8 pt-10">
        <Link to="/" data-testid="privacy-logo" className="font-display font-extrabold tracking-tight">
          <span className="text-gold">Local</span>Business<span className="text-gold">Jingle</span><span className="text-slate-500">.com</span>
        </Link>
      </header>
      <main className="flex-1 mx-auto w-full max-w-4xl px-4 sm:px-8 py-14">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold mb-4">Legal</p>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-4">Privacy Policy</h1>
        <p className="text-sm text-slate-500 mb-12">Last updated: September 2026</p>
        <div className="space-y-10">
          {SECTIONS.map((s, i) => (
            <section key={i}>
              <h2 className="font-display text-xl font-bold mb-3">{s.title}</h2>
              <p className="text-slate-400 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
